// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1EJ3-","content":"Consent_content__125tn","footer":"Consent_footer__n1Mw8"};